import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useInView } from "framer-motion";
import Lightbox from "yet-another-react-lightbox";
import GalleryNationalPromotions from "./GalleryNationalPromotions";
import "./NationalPromotionsMedia.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { BsChevronDoubleRight } from "react-icons/bs";

const NATIONAL = [
  {
    id: "np-01",
    title:
      "Curtain Raiser Of Bharat Buildcon 2026 By Shri Piyush Goyal, Hon. Minister Of Commerce & Industry",
    place: "New Delhi",
    img: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=900&auto=format&fit=crop",
    images: [
      {
        src: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=1600&auto=format&fit=crop",
        caption: "Shri Piyush Goyal addressing the gathering",
      },
      {
        src: "https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=1600&auto=format&fit=crop",
        caption: "Dignitaries on the dais",
      },
      {
        src: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?q=80&w=1600&auto=format&fit=crop",
        caption: "Curtain raiser banner unveiling",
      },
      {
        src: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?q=80&w=1600&auto=format&fit=crop",
        caption: "Guests in attendance",
      },
      {
        src: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?q=80&w=1600&auto=format&fit=crop",
        caption: "Panel discussion",
      },
      {
        src: "https://images.unsplash.com/photo-1515187029135-18ee286d815b?q=80&w=1600&auto=format&fit=crop",
        caption: "Networking after the session",
      },
    ],
  },
  {
    id: "np-02",
    title:
      "Indian Small Scale Paint Association — Export Knowledge Sharing Event",
    place: "Mumbai",
    img: "https://images.unsplash.com/photo-1591115765373-5207764f72e7?q=80&w=900&auto=format&fit=crop",
    images: [
      {
        src: "https://images.unsplash.com/photo-1591115765373-5207764f72e7?q=80&w=1600&auto=format&fit=crop",
        caption: "Association Chairman keynote presentation",
      },
      {
        src: "https://images.unsplash.com/photo-1577495508048-b635879837f1?q=80&w=1600&auto=format&fit=crop",
        caption: "Government Export Promotion Board address",
      },
      {
        src: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=1600&auto=format&fit=crop",
        caption: "Industry leaders technical round table",
      },
      {
        src: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?q=80&w=1600&auto=format&fit=crop",
        caption: "Delegates & business chiefs networking",
      },
    ],
  },
  {
    id: "np-03",
    title: "Rajkot Hardware Association Meet",
    place: "Rajkot",
    img: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=900&auto=format&fit=crop",
    images: [
      {
        src: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=1600&auto=format&fit=crop",
        caption: "Lighting of lamp inaugural ceremony",
      },
      {
        src: "https://images.unsplash.com/photo-1560439514-4e9645039924?q=80&w=1600&auto=format&fit=crop",
        caption: "Rajkot Hardware Association leadership on stage",
      },
      {
        src: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?q=80&w=1600&auto=format&fit=crop",
        caption: "Industrialists & delegates assembly",
      },
    ],
  },
  {
    id: "np-04",
    title: "Builders & Developers Round Table",
    place: "Ahmedabad",
    img: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=900&auto=format&fit=crop",
    images: [
      {
        src: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=1600&auto=format&fit=crop",
        caption: "Real estate & infrastructure CEO summit",
      },
      {
        src: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?q=80&w=1600&auto=format&fit=crop",
        caption: "Ministry officials & developers dialogue",
      },
      {
        src: "https://images.unsplash.com/photo-1515187029135-18ee286d815b?q=80&w=1600&auto=format&fit=crop",
        caption: "MoU signing & strategic partnership announcement",
      },
    ],
  },
  {
    id: "np-05",
    title: "Ceramic Manufacturers Conclave",
    place: "Morbi",
    img: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?q=80&w=900&auto=format&fit=crop",
    images: [
      {
        src: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?q=80&w=1600&auto=format&fit=crop",
        caption: "Morbi Ceramic Conclave inaugural stage",
      },
      {
        src: "https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=1600&auto=format&fit=crop",
        caption: "State ministers & industry chiefs keynote",
      },
      {
        src: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?q=80&w=1600&auto=format&fit=crop",
        caption: "Tile & ceramic industrialists delegation",
      },
    ],
  },
  {
    id: "np-06",
    title: "Sanitaryware Traders Meet",
    place: "Surat",
    img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=900&auto=format&fit=crop",
    images: [
      {
        src: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=1600&auto=format&fit=crop",
        caption: "Sanitaryware trade leaders keynote address",
      },
      {
        src: "https://images.unsplash.com/photo-1515187029135-18ee286d815b?q=80&w=1600&auto=format&fit=crop",
        caption: "Federation executives panel discussion",
      },
      {
        src: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?q=80&w=1600&auto=format&fit=crop",
        caption: "Delegates group interaction & honors",
      },
    ],
  },
];

/* Reveal-on-scroll photo tile: starts desaturated & soft, "develops"
   into full colour + sharpness once it enters the viewport. */
function PhotoTile({ item, index, onOpen }) {
  const ref = useRef(null);
  const isDeveloped = useInView(ref, { once: true, amount: 0.25 });

  const tilt = index % 2 === 0 ? "-1.1deg" : "1.3deg";

  return (
    <figure
      ref={ref}
      className={`npm-tile${isDeveloped ? " is-developed" : ""}`}
      style={{ "--npm-tilt": tilt, "--npm-delay": `${(index % 6) * 0.08}s` }}
      onClick={() => onOpen(index)}
      role="button"
      tabIndex={0}
      aria-label={`Open photo ${index + 1}: ${item.caption || ""}`}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onOpen(index)}
    >
      <span className="npm-tile__frame">
        <span className="npm-tile__sheen" aria-hidden="true" />
        <img
          src={item.src}
          alt={item.caption || "Event photo"}
          loading="lazy"
        />
        {/* <span className="npm-tile__hover">
          <span className="npm-tile__hover-icon">
            <ExpandIcon />
          </span>
          <span className="npm-tile__hover-text">View full size</span>
        </span> */}
      </span>
      {item.caption && (
        <figcaption className="npm-tile__cap">{item.caption}</figcaption>
      )}
    </figure>
  );
}

export default function NationalPromotionsMedia() {
  const { id } = useParams();

  const [lightboxIndex, setLightboxIndex] = useState(-1);

  // Scroll to the top whenever a different album is opened.
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant" in window ? "instant" : "auto",
    });
  }, [id]);

  if (!id) {
    return <GalleryNationalPromotions />;
  }

  const album = NATIONAL.find((n) => n.id === id) || NATIONAL[0];

  const images =
    album && album.images && album.images.length ? album.images : [{ src: album ? album.img : "" }];
  const slides = images.map((item) => ({
    src: item.src,
    title: item.caption,
    description: album ? album.title : "",
  }));

  return (
    <section className="npm">
      <div className="npm__lightleak" aria-hidden="true" />
      <div className="npm__grain" aria-hidden="true" />

      <header className="npm__hero">
        <div className="clean-breadcrumb-wrapper">
          <nav className="about-style-breadcrumb" aria-label="Breadcrumb">
            <Link to="/" className="bc-home-link">
              HOME
            </Link>
            <span className="bc-slash">/</span>
            <span className="bc-active-page">NATIONAL PROMOTIONS</span>
          </nav>
        </div>
        <h1 className="npm__title">National Promotions</h1>
      </header>

      <div className="npm__trail">
        <Link to="/gallery#nationalpromotions" className="npm__trail-link">
          Main Album
        </Link>
        <span className="npm__trail-sep">
          <BsChevronDoubleRight />
        </span>
        <span className="npm__trail-current">{album.title}</span>
      </div>

      {/* {album.place && (
        <div className="npm__meta">
          <span className="npm__meta-dot" />
          {album.place} &middot; {images.length} photo
          {images.length !== 1 ? "s" : ""}
        </div>
      )} */}

      <div className="npm__grid">
        {images.map((item, i) => (
          <PhotoTile key={i} item={item} index={i} onOpen={setLightboxIndex} />
        ))}
      </div>

      <Lightbox
        open={lightboxIndex >= 0}
        index={lightboxIndex}
        close={() => setLightboxIndex(-1)}
        slides={slides}
        plugins={[Zoom]}
        thumbnails={{ position: "bottom", border: 0, gap: 8, padding: 0 }}
        // counter={{ container: { style: { top: "unset", bottom: 0 } } }}
        animation={{ swipe: 280 }}
      />
    </section>
  );
}
